const closeButtonLabel = "Fermer";
const frCH = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  frCH as default
};
